import styled from 'styled-components'

export const Container = styled.div`
  display: grid;
  gap: 16px;
`

export const Card = styled.div`
  background-color: ${({ theme }) => theme.cor40}!important;
  padding: 24px;
  border-radius: 8px;
  display: grid;
  gap: 24px;
`

export const Section = styled.div`
  display: grid;
  gap: 12px;
  width: 100%;
`

export const SectionLabel = styled.span`
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  color: ${({ theme }) => theme.cor9};
`

export const FieldsRow = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr 1fr;
`

export const RadioWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
`
